export class MedicalReviewReportContext {

    constructor(public customerNumberId: number, public reportId: number, public businessTransactionId: number) { }

    public createNewReport: boolean;
    public isReadOnly: boolean;
}
